<template>
    <div class = 'col-md-12'>
        <div class="row">
        <div class = 'col-md-4' v-for='project in projects' :key="project.title">
              <project-card v-bind="project"></project-card>
        </div>
      </div>
    </div>
</template>

<style type="text/css">

</style>

<script>
import ProjectsService from '@/services/ProjectsService'
import ProjectCard from '@/components/ProjectCard'
// import json from '@/assets/data/projects.json'

export default {
  name: 'projects',
  components: {
    ProjectCard
  },

  data () {
    return {
      airtableResponse: []
    }
  },

  mounted: function () {
    const self = this
    async function getProjects () {
      try {
        const response = await ProjectsService.getProjects()
        self.airtableResponse = response.data.records
        console.log(self.airtableResponse)
      } catch (err) {
        console.log(err)
      }
    }
    getProjects()
  },

  computed: {
    projects () {
      const self = this
      const projectList = []
      for (var i = 0; i < self.airtableResponse.length; i++) {
        if (self.airtableResponse[i].fields.published) {
          const project = {
            title: self.airtableResponse[i].fields.title,
            abstract: self.airtableResponse[i].fields.abstract,
            authors: self.airtableResponse[i].fields.author,
            slug: self.airtableResponse[i].fields.slug,
            snippet: self.airtableResponse[i].fields.snippet
          }
          projectList.push(project)
        }
      }
      return projectList
    }
  }
}
</script>
